/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { useLocationStore } from '@ahm/react-map/store';
import { Button, Group, rem, type ButtonProps } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useOptimizedRouteHook } from '@/hooks';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type Props = ButtonProps & {
  onClick: () => void;
};

function AddPathBtn({ onClick, ...btnProps }: Props) {
  const isMobile = useIsMobile();
  const tBooking = useTranslations('booking');
  const paths = useLocationStore.use.paths();

  const { checkNeedOptimize, handleOptimizeRoutes } = useOptimizedRouteHook();

  return (
    <Group mx={8} py={3} justify="space-between">
      <Button
        ml={-2}
        px="sm"
        onClick={onClick}
        fullWidth={paths.length < 2}
        variant="subtle"
        color="primary"
        justify="flex-start"
        radius={rem(4)}
        size={isMobile ? 'sm' : 'md'}
        leftSection={
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="16" height="16" rx="8" fill="currentColor" />
            <path
              d="M12 7.14286H8.85714V4H7.14286V7.14286H4V8.85714H7.14286V12H8.85714V8.85714H12V7.14286Z"
              fill="white"
            />
          </svg>
        }
        styles={{
          inner: {
            fontSize: isMobile ? rem(16) : rem(18),
            fontWeight: 700,
          },
        }}
        {...btnProps}
      >
        {tBooking('location.add_delivery_point')}
      </Button>
      {paths.length > 2 && checkNeedOptimize ? (
        <Button
          px="sm"
          onClick={handleOptimizeRoutes}
          fullWidth={paths.length < 2}
          variant="subtle"
          color="primary"
          justify="flex-start"
          radius={rem(4)}
          size={isMobile ? 'sm' : 'md'}
          styles={{
            inner: {
              fontSize: isMobile ? rem(16) : rem(18),
              fontWeight: 700,
            },
          }}
          {...btnProps}
        >
          {tBooking('location.optimize_route')}
        </Button>
      ) : null}
    </Group>
  );
}

export default AddPathBtn;
